'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactSlidedown = require('react-slidedown');

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./TargetDateSeriesFundDetails.css');

var TargetDateSeriesFundDetails = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateSeriesFundDetails, _Component);

  function TargetDateSeriesFundDetails(props) {
    (0, _classCallCheck3.default)(this, TargetDateSeriesFundDetails);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TargetDateSeriesFundDetails.__proto__ || (0, _getPrototypeOf2.default)(TargetDateSeriesFundDetails)).call(this, props));

    _this.state = {
      targetDateSeries: props.targetDateSeries,
      showFundDetails: false
    };
    return _this;
  }

  (0, _createClass3.default)(TargetDateSeriesFundDetails, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showFundDetails = _state.showFundDetails,
          targetDateSeries = _state.targetDateSeries;


      return _react2.default.createElement(
        'div',
        { styleName: 'fund-details-wrap' },
        _react2.default.createElement(
          'button',
          {
            styleName: 'fund-details-button',
            onClick: function onClick() {
              _this2.setState({
                showFundDetails: !showFundDetails
              });
            }
          },
          'Fund details',
          _react2.default.createElement(_components.LinkIcon, {
            faclass: showFundDetails ? 'fa-chevron-up' : 'fa-chevron-down'
          })
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          showFundDetails ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'dtls-tbl-row' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-lbl' },
                'Target date fund series name'
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-val' },
                _react2.default.createElement(
                  'b',
                  null,
                  targetDateSeries.strategy_name
                )
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'dtls-tbl-row' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-lbl' },
                'Fund name'
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-val' },
                _react2.default.createElement(
                  'b',
                  null,
                  targetDateSeries.fund_legal_name
                )
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'dtls-tbl-row' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-lbl' },
                'Fund tickers'
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-val' },
                _react2.default.createElement(
                  'b',
                  null,
                  targetDateSeries.tickers
                )
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'dtls-tbl-row' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-lbl' },
                'Fund manager'
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-val' },
                _react2.default.createElement(
                  'b',
                  null,
                  targetDateSeries.fund_family_label
                )
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'dtls-tbl-row' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-lbl' },
                'Fund group'
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-val' },
                _react2.default.createElement(
                  'b',
                  null,
                  targetDateSeries.category_group
                )
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'dtls-tbl-row' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-lbl' },
                'Fund category'
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-val' },
                _react2.default.createElement(
                  'b',
                  null,
                  targetDateSeries.morningstar_category_name
                )
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'dtls-tbl-row' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-lbl' },
                'Percent rated'
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-val r' },
                _react2.default.createElement(
                  'b',
                  null,
                  _format2.default.perc(targetDateSeries.percent_rated)
                )
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'dtls-tbl-row' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-lbl' },
                'Percent rated, long assets'
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-val r' },
                _react2.default.createElement(
                  'b',
                  null,
                  _format2.default.perc(targetDateSeries.percent_rated_long)
                )
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'dtls-tbl-row' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-lbl' },
                'Fund net assets'
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 6, styleName: 'dtls-tbl-val r' },
                _react2.default.createElement(
                  'b',
                  null,
                  _format2.default.money(targetDateSeries.net_assets, true, 'US Dollar')
                )
              )
            )
          ) : null
        )
      );
    }
  }]);
  return TargetDateSeriesFundDetails;
}(_react.Component), _class2.propTypes = {
  // the target date series object
  targetDateSeries: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = TargetDateSeriesFundDetails;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesFundDetails/TargetDateSeriesFundDetails.js
// module id = 1448
// module chunks = 0